import React from 'react';

const DropdownButton = ({ isOpen, placeholder }) => {
  return (
    <button className="w-full inline-flex items-center justify-between px-3 py-2 border border-gray-300 rounded-lg bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary-500">
      <span className="text-gray-500">{placeholder}</span>
      <svg
        className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path d="M19 9l-7 7-7-7"></path>
      </svg>
    </button>
  );
};

export default DropdownButton;